import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock-upgrade'

const jsMenu = () => {
  const openMenuEl: HTMLElement | null = document.querySelector(".jsMenuToggle");
  const closeMenuEl: HTMLElement | null = document.querySelector(".jsMenuClose");
  const menuEl: HTMLElement | null = document.querySelector('.jsMenuContainer');

  const mobileNav: HTMLElement | null = document.querySelector('.sb-mobile-nav__content');
  if (menuEl && mobileNav) {
    openMenuEl?.addEventListener('click', () => {
      disableBodyScroll(mobileNav);
      menuEl.classList.add('is-open');
    });

    closeMenuEl?.addEventListener('click', () => {
      enableBodyScroll(mobileNav);
      menuEl.classList.remove('is-open');
    });
  }
}

const footerMenu = () => {
  const footerMenuParentLinks = document.querySelectorAll(".sb-mobile-nav__nav .sb-main-nav-parent > .sb-main-nav__link");
  footerMenuParentLinks.forEach(parentLink => {
    parentLink.addEventListener('click', () => {
      parentLink.classList.toggle('is-open')
    })
  })
}

const mobileMegaMenu = () => {
  const menu =  document.querySelector(".sb-mobile-nav__nav")
  if (!menu) return

}

const desktopMegaMenu = () => {
  const menu =  document.querySelector(".sb-c-main-nav");
  if (!menu) return
  menuDecorator(menu)
}

const menuDecorator = (menu) => {
  if (!menu) return

  const elements: HTMLLIElement[] = menu.querySelectorAll('.sb-main-nav-item')

  const toggleHover = (link: HTMLElement, hover: boolean) => {
    if (!Array.from(link.classList).includes('button')) {
      console.log('granting hover')
      link.classList.toggle("hover", hover);
    }
  }

  const resetHover = () => {
    // set it to 0 first because there's no gap between items any more
    menu.style.setProperty("--underline-width", `0`);

    // turn the delay off so it just disappears
    menu.style.setProperty("--underline-delay", `0s`);

    elements.forEach(el => {
      const link = el.querySelector('a')
      if (link) {
        link.classList.remove('hover')
      }
    })
  }

  const handleLinkHover = (target: HTMLElement) => {
    const menuElParent = target.closest('nav') as HTMLElement
    // somehow we're not in the top bar, so abandon ship
    if (!menuElParent) return false

    // otherwise, let's hover the heck out of this.
    // items with a button inside reset the offsetParent to be the <li>, because of course they do.
    let offsetParent:HTMLElement|null = target.offsetParent as HTMLElement

    let offsetValue = target.offsetLeft

    if (offsetParent?.nodeName === 'LI')  {
      offsetParent = target.offsetParent as HTMLElement
      offsetValue = offsetParent.offsetLeft
    }
    menu.style.setProperty("--underline-offset-x", `${offsetValue - menuElParent?.offsetLeft}px`);
    setTimeout(() => {
      // reset the delay so it shows up smoothly
      menu.style.setProperty("--underline-delay", `.25s`);
      menu.style.setProperty("--underline-width", `${target.offsetWidth}px`);
    }, 125)
  }

  const handleMouse = (evt: Event) => {
    const type:string|null = evt.type || null;

    let target = evt.target as HTMLElement;
    if (type === null || !target) return

    if (type === 'mouseleave' && target.nodeName === 'NAV') {
      // we've removed ourselves from the menu entirely
      resetHover()
    }

    // stop the hover event bubbling to the list, we will handle it manually
    evt.stopImmediatePropagation()

    if (!target || target.classList.contains('hover')) return

    resetHover()

    toggleHover(target, type === 'mouseover');
    if (target.nodeName === 'A' && !Array.from(target.classList).includes('button')) handleLinkHover(target)
  }

  Array.from(elements).forEach(el => {
    const trigger = el.querySelector('a')
    if (!trigger) return false
    trigger.addEventListener("mouseover", handleMouse);
  })

  menu.addEventListener("mouseleave", handleMouse);
}

export {
  jsMenu,
  footerMenu,
  desktopMegaMenu,
  mobileMegaMenu
}
